import React, { useState } from 'react';

const DownloadSection = ({
  refProp,studies, folders, files, allFiles, selectedStudy, selectedFolder,
  loading, onStudyChange, onFolderChange, onFileDownload, onToggleFiles
}) => {
  const [showAllFiles, setShowAllFiles] = useState(false);

  const handleToggleFiles = () => {
    setShowAllFiles(!showAllFiles);
    onToggleFiles(!showAllFiles);
  };

  return (
    <section ref={refProp} className="download-section">
      <h2>Associated imzML Files</h2>
      <label>
        Select Study:
        <select value={selectedStudy} onChange={onStudyChange}>
          <option value="">Select Study</option>
          {studies.map(study => <option key={study} value={study}>{study}</option>)}
        </select>
      </label>

      <label>
        Select Sub-Study:
        <select value={selectedFolder} onChange={onFolderChange} disabled={!selectedStudy}>
          <option value="">Select Sub-Study</option>
          {folders.map(folder => <option key={folder} value={folder}>{folder}</option>)}
        </select>
      </label>

      <div>
        <h3>Files:</h3>
        {loading ? (
          <div className="spinner"></div>
        ) : (
          <>
            {files.map(file => (
              <div className="download" key={file}>
                <span>{file}</span>
                <button onClick={() => onFileDownload(file)} className="download-file">Download</button>
              </div>
            ))}
            {allFiles.length > 2 && (
              <button onClick={handleToggleFiles} className="download-button">
                {showAllFiles ? "Less" : "More"}
              </button>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default DownloadSection;
